import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';

import { type ConfirmRequest, confirm } from '@/components/molecules/ConfirmDialog';

/**
 * Asks with `question`, in the portal's confirmation dialog, before an in-app navigation (a
 * link, the back button) while `when` holds, and stays put when the reader declines. A change
 * of the hash alone stays on the page, so it is let through. Needs the data router Root
 * renders, and the ConfirmHost it mounts.
 */
export function useInAppLeaveGuard(when: boolean, question: ConfirmRequest): void {
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            when &&
            (currentLocation.pathname !== nextLocation.pathname ||
                currentLocation.search !== nextLocation.search)
    );
    // The blocker re-renders while the dialog is open; this keeps it to one question.
    const asking = useRef(false);

    useEffect(() => {
        if (blocker.state !== 'blocked' || asking.current) return;
        asking.current = true;
        void confirm(question).then((leave) => {
            asking.current = false;
            if (leave) blocker.proceed();
            else blocker.reset();
        });
    }, [blocker, question]);
}
